<template>
  <div id="payrollTable">
    <div class="header">
      <div class="title">{{ accountInfoData }}公司员工工资表</div>
      <div class="baseInfo">{{ accountInfoDataTime }}人员工资</div>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      :cell-style="{ borderColor: '#666666' }"
      :header-cell-style="{ borderColor: '#666666' }"
    >
      <el-table-column
        v-for="item in tableConfig"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
      >
        <template v-if="item.children && item.children.length">
          <el-table-column
            v-for="child in item.children"
            :key="child.prop"
            :label="child.label"
            :prop="child.prop"
            :width="child.width"
          >
            <template v-slot="scope">
              <el-input
                size="mini"
                v-if="!showEdit"
                maxlength="15"
                v-model="scope.row[child.prop]"
              ></el-input>
              <span v-else>
                {{ scope.row[child.prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
        <template v-slot="scope" v-if="item.prop == 'index'">
          <span>{{ previousTotal + scope.$index + 1 }}</span>
        </template>
        <template v-slot="scope" v-else>
          <template v-if="item.prop == 'netSalary'">
            {{ getSalary(scope.row) }}
          </template>
          <template v-else>
            <el-input
              size="mini"
              v-if="!showEdit"
              :disabled="item.disabled"
              v-model="scope.row[item.prop]"
            ></el-input>
            <span v-else>
              {{ scope.row[item.prop] }}
            </span>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { uploadUrlTwo } from "@/assets/js/apiConfig.js";
import html2canvas from "html2canvas";
import { payRollTableHeader } from "@/assets/js/printTemplate.js";
export default {
  props: {
    previousTotal: {
      type: Number,
      default: 0,
    },
    currentPage:{
      type:Number|String,
      default:1,
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    accountInfoData() {
      return this.$store.state.accountInfo.accountInfoData.name;
    },
    accountInfoDataTime() {
      return this.$util.formatDate.format(
        this.$store.state.accountInfo.accountInfoData.yearPeriodTimeStamp,
        "yyyy年MM月"
      );
    },
  },
  data() {
    return {
      showEdit: false,
      tableConfig: payRollTableHeader,
    };
  },
  methods: {
    getSalary(row){
        const number = (Number(row.needPay) - Number(row.pensionInsurance) - Number(row.medicalInsurance) - Number(row.unemploymentInsurance) - Number(row.monthTax) - Number(row.houseRent)) || ''
        console.log(number)
        return number?number.toFixed(2)== '-0.00'?0:number.toFixed(2):''
    },
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const bstr = atob(arr[1]);

      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: "image/png" });
    },
    changeEdit(key) {
      this.showEdit = key;
    },
    async generateImage(key) {
      await this.changeEdit(key);
      const element = document.getElementById("payrollTable");
      const canvas = await html2canvas(element, {
        useCORS: true, // 允许跨域图片
        logging: false, // 关闭警告
        width: 1180,
        height: 562,
        // scale: 2,
        ignoreElements: (element) => false, // 强制渲染所有元素
      });
      console.log(canvas);
      const imgUrl = canvas.toDataURL("image/png");
      // 转 File 对象
      const file = this.dataURLtoFile(imgUrl, `工资表_${this.currentPage}.png`);
      const formatDate = new FormData();
      formatDate.append("file", file);
      const { data } = await this.$http.post(uploadUrlTwo, formatDate, {
        upload: true,
      });
      return Promise.resolve(data.data[0]);
    },
  },
};
</script>

<style lang="less" scoped>
#payrollTable {
  padding: 2px;
}
/deep/ .el-table th.el-table__cell > .cell {
  display: flex;
  justify-content: center;
  align-items: center;
}
.header {
  height: 60px;
  border: 1px solid #666666;
  box-sizing: border-box;
  border-bottom: 0;
  display: flex;
  flex-direction: column;
  .title,
  .baseInfo {
    text-align: center;
    padding: 6px 0px;
    box-sizing: border-box;
    font-size: 12px;
    //   line-height: 30px;
    color: #333333;
  }
  .baseInfo {
    // display: flex;
    // padding: 0;
    // .date {
    //   padding: 6px 0px;
    //   width: 160px;
    //   box-sizing: border-box;
    // }
    // .unit {
    //   flex: 1;
    //   box-sizing: border-box;
    //   padding: 6px 0px;
    //   border-right: 1px solid #666666;
    // }
  }
  .title {
    border-bottom: 1px solid #666666;
  }
}
/deep/ .el-table__footer-wrapper td.el-table__cell {
  border-top: 1px solid #666666 !important;
  border-right: 1px solid #666666 !important;
}
/deep/ .el-table__cell {
  padding: 0 !important;
  .cell {
    text-align: center;
    padding: 2px !important;
    font-size: 12px !important;
    color: #333333 !important;
    line-height: 12px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 30px !important;
  }
}
/deep/ .el-table--border,
.el-table--group {
  border: 1px solid #666666 !important;
  // border-color: #666666!important;
}
</style>



// WEBPACK FOOTER //
// src/components/table/payrollTable.vue